import { FamilyNewsletterOptionsEnum } from '@/consts/newsletter';
import { disableFamilyNewsletterOption } from '@/utils/disableFamilyNewsletterOption';

export default {
  name: "Other",
  props: {
    settings: null,
    arecheckedesdisabled: Boolean,
    facility: null,
    facilityCopy: null
  },
  computed: {
    otherCategory: {
      get() {
        return (
          (this.facility.featureOther ?? true) &&
          (this.facility.isEnabledAddFriendsFromOtherCommunities ?? true) &&
          (this.facility.isEnabledResidentWingVisibleForOtherResidents ?? true) &&
          (this.facility.isEnabledResidentInformationVisibleForOtherResidents ?? true) &&
          (this.facility.isEnableResidentReligion ?? true)
        );
      }
    }
  },
  methods: {
    otherCategoryUpdate(value) {
      this.facility.featureOther = value;
      this.facility.isEnabledAddFriendsFromOtherCommunities = value;
      this.facility.isEnabledResidentWingVisibleForOtherResidents = value;
      this.facility.isEnabledResidentInformationVisibleForOtherResidents = value;
      this.facility.isEnableResidentReligion = value;
    },
    friendsFromOtherCommunitiesUpdate(value) {
      if (!value) {
        disableFamilyNewsletterOption(this.facility, FamilyNewsletterOptionsEnum.FriendsAdded);
      }
    }
  }
}